export default function Footer() {
  return (
    <footer
      className="border-t border-stone-200 bg-[#FAF7F2] py-12 px-6 lg:px-12"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex flex-col items-start leading-tight">
          <span className="flex items-center gap-0.5">
            <img
              src="/brand-icon.png"
              alt=""
              aria-hidden="true"
              className="h-7 w-7 object-contain"
            />
            <span className="font-display font-semibold tracking-tight text-stone-900 text-2xl">
              DMV
            </span>
          </span>
          <span className="font-display font-semibold tracking-tight text-stone-700 text-base mt-0.5">
            Floor Plans
          </span>
          <div className="text-[10px] tracking-wider uppercase text-stone-500 font-semibold mt-1">
            dmvfp.com
          </div>
        </div>

        <nav className="flex flex-wrap gap-2 text-sm">
          <a href="/#services" className="px-4 py-2 rounded-full text-stone-700 hover:bg-stone-100" data-testid="footer-link-services">
            Services
          </a>
          <a href="/portfolio" className="px-4 py-2 rounded-full text-stone-700 hover:bg-stone-100" data-testid="footer-link-portfolio">
            Portfolio
          </a>
          <a href="/#process" className="px-4 py-2 rounded-full text-stone-700 hover:bg-stone-100" data-testid="footer-link-process">
            Process
          </a>
          <a href="/#contact" className="px-4 py-2 rounded-full text-stone-700 hover:bg-stone-100" data-testid="footer-link-contact">
            Contact
          </a>
        </nav>

        <div className="text-xs text-stone-500">
          © 2026 DMVFloorPlans. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
